document.addEventListener("DOMContentLoaded", function () {
  const hideBodyOverflow = () => {
    const activeModal = Array.from(document.querySelectorAll(".modal.is_open"));

    document.body.style.overflow =
      activeModal && activeModal.length > 0 ? "hidden" : "visible";
  };

  const initProductSlider = () => {
    /*********************
      Thumbnails slider
    *********************/
    // Change the main image whenever a thumbnail button is activated
    function relatedSlider() {
      const thumbs = document.querySelectorAll(
        ".thumbnails-slider .thumbnail-button"
      );
      if (thumbs) {
        thumbs.forEach((thumb) => {
          thumb.addEventListener("click", () => {
            thumbs.forEach((e) => e.setAttribute("aria-current", false));
            thumb.setAttribute("aria-current", true);

            const index = thumb.closest(".slick-slide").dataset.slickIndex;

            $(".main-image-slider").slick("slickGoTo", index);
          });
        });
      }

      setTimeout(() => {
        $(".thumbnails-slider").slick("refresh");
        $(".main-image-slider").slick("refresh");
      }, 500);
    }
    $(".thumbnails-slider").on("init", relatedSlider);
    $(".thumbnails-slider").on("reinit", relatedSlider);

    // Initialize the slider
    $(".thumbnails-slider")
      .not(".slick-initialized")
      .slick({
        slidesToShow: 5,
        infinite:false,
        regionLabel: "thumbnails carousel",
        prevArrow: $(".main-slider-arrow .icons-left svg"),
        nextArrow: $(".main-slider-arrow .icons-right svg"),
      });

    /********************
      Main image slider
    *********************/
    $(".main-image-slider").not(".slick-initialized").slick({
      arrows: false,
      dots: true,
      slidesToShow: 1,
      regionLabel: "main image carousel"
      
    });

    // Update the thumbnail slider when the user changes the main slider directly.
    $(".main-image-slider").on(
      "beforeChange",
      function (e, slider, currentSlide, nextSlide) {
        // Remove aria-current from the last selected thumbnail image button
        $(
          '.thumbnails-slider .thumbnail-button[aria-current="true"]'
        ).removeAttr("aria-current");

        // Select the thumbnail image button that goes with this main image. Most importantly, this updates Slick's internal state to be consistent with the visual change.
        $(".thumbnails-slider").slick("slickGoTo", nextSlide);

        // Add aria-current="true" to the correct thumbnail image button to convey to screen readers that it's active.
        $(".thumbnails-slider .thumbnail-button:eq(" + nextSlide + ")").attr(
          "aria-current",
          true
        );
      }
    );
  };
  initProductSlider();

  let ingredientsSlider;
  const initSliderIng = () => {
    if (ingredientsSlider) return;

    if (window.innerWidth < 600) {
      ingredientsSlider = $(".slider-ingredients")
        .not(".slick-initialized")
        .slick({
          dots: true,
          speed: 300,
          infinite: true,
          mobileFirst: true,
          slidesToShow: 2,
          slidesToScroll: 2,
          prevArrow: $(".key-ingredients .icons-left svg"),
          nextArrow: $(".key-ingredients .icons-right svg"),
          responsive: [
            {
              breakpoint: 600,
              settings: "unslick",
            },
          ],
        });

      ingredientsSlider.on("destroy", () => {
        ingredientsSlider = false;
      });
    }
  };
  initSliderIng();

  window.addEventListener("resize", initSliderIng);

  let relatedSlider;
  const initSliderRelated = () => {
    if (relatedSlider) return;

    relatedSlider = $(".slider-also-love")
      .not(".slick-initialized")
      .slick({
        speed: 300,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        prevArrow: $(".icons-lefts svg"),
        nextArrow: $(".icons-rights svg"),
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
        ],
      });
  };
  initSliderRelated();

  /* Open / Close modal */

  const toggleModal = (modal, status) => {
    if (status) modal.classList.add("is_open");
    else modal.classList.remove("is_open");

    hideBodyOverflow();
  };

  document.querySelectorAll(".close-modal").forEach((closeBtn) =>
    closeBtn.addEventListener("click", (e) => {
      toggleModal(e.target.closest(".modal"), false);
    })
  );

  const modalSwitchProducts = document.querySelector("#modal-products");
  if (modalSwitchProducts) {
    const switchProducts = document.querySelectorAll(
      ".switch-product-container li"
    );

    if (switchProducts && typeof productsData != "undefined") {
      const mainImages = document.querySelector(".main-image-slider");
      const mainThumbs = document.querySelector(".thumbnails-slider");
      const modalProduct = document.querySelector(
        ".product-media-modal__content"
      );
      const mainArrows = document.querySelector(".main-slider-arrow");

      const prodId = document.querySelector(".product-id");
      const prodTitle = document.querySelector(".icons-star-title");
      const prodDesc = document.querySelector(".product-description");
      const prodDisclaimer = document.querySelector(".description-two");

      const sliderIng = document.querySelector(".slider-ingredients");

      const related = document.querySelector(".slider-also-love");

      switchProducts.forEach((switchProduct) => {
        switchProduct.addEventListener("click", (e) => {
          if (e.target.closest("variant-radios")) return;

          const width =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;

          if (width < 1150 && switchProduct.classList.contains("selected"))
            return toggleModal(modalSwitchProducts, true);

          /* Remove class to prev item */
          const prevItems = document.querySelectorAll(
            ".switch-product-container li.selected"
          );
          prevItems.forEach((i) => i.classList.remove("selected"));

          /* Add class selected to new item */
          const nextItems = document.querySelectorAll(
            `li[data-id="${switchProduct.dataset.id}"]`
          );
          nextItems.forEach((i) => i.classList.add("selected"));

          const product = productsData.filter(
            (elem) => elem.id == switchProduct.dataset.id
          )[0];

          /* Product Slider */
          mainImages.classList.add("hidden");
          mainThumbs.classList.add("hidden");
          mainArrows.classList.add("hidden");

          $(mainImages).slick("unslick");
          $(mainThumbs).slick("unslick");

          mainThumbs.innerHTML = "";

          mainImages.innerHTML = product.slider;
          modalProduct.innerHTML = product.media;
          if (product.images.length > 0) {
            product.images.forEach((image, index) => {
              if (product.images.length > 1) {
                mainThumbs.innerHTML += `<button class="thumbnail-button" ${
                  index === 0 ? 'aria-current="true"' : ""
                }>
                  <img loading="lazy" class="img-slider" src="${
                    image.url
                  }" alt="${image.alt}" width="100" height="120">
                </button>`;
              }
            });

            mainImages.classList.remove("hidden");
            mainThumbs.classList.remove("hidden");
            mainArrows.classList.remove("hidden");

            initProductSlider();
          }

          /* Product Info */
          prodId.value = product.id;
          prodTitle.innerHTML = `${product.rating}`;
          prodDesc.innerHTML = `${product.description}`;
          prodDisclaimer.innerHTML = `${product.disclaimer}`;

          document.querySelector(".price-container").innerHTML = `${product.price}`;

          /* Key Ingredients */
          if (ingredientsSlider) {
            ingredientsSlider.slick("unslick");
            ingredientsSlider = false;
          }

          if (sliderIng) {
            sliderIng.innerHTML = "";
            if (product.key_ingredients) {
              product.key_ingredients.forEach((key_ingredient) => {
                document.querySelector(
                  ".slider-ingredients"
                ).innerHTML += `<div class="img-ingredients">
                <img class="img-key" src="${key_ingredient.image}">
                <p class="name-ingredients">${key_ingredient.name}</p>
              </div>`;
              });
              initSliderIng();
            }
          }

          if (relatedSlider) {
            relatedSlider.slick("unslick");
            relatedSlider = false;
          }

          if (related) {
            related.innerHTML = "";
            if (product.related_product) {
              product.related_product.forEach((related_produc) => {
                let logo = "";
                if (related_produc.showLogo && related_produc.logo != "") {
                  logo = `<img class="logo-sensitive" src="${related_produc.logo}" alt="">`;
                }
                document.querySelector(
                  ".slider-also-love"
                ).innerHTML += `<div class="content-slider-also-love">
                  ${logo}
                  <img
                    loading="lazy"
                    class="img-products"
                    src="${related_produc.src}"
                    alt="${related_produc.alt}">

                  <div class="content-text-button">
                    <h1>${related_produc.title}</h1>
                    <p>${related_produc.subtitle}</p>

                    ${related_produc.form}
                  </div>
                </div>`;
              });

              initSliderRelated();
            }
          }

          toggleModal(modalSwitchProducts, false);

          /* Browser Url */
          window.history.replaceState({}, "", product.url);

          const variantsMobile = document.querySelectorAll(".variants-mobile");
          variantsMobile.forEach((variant) => {
            variant.classList.remove("active");
            if (variant.dataset.url == product.url) {
              variant.querySelector("select").value =
                variant.querySelector("option").value;

              variant.dispatchEvent(new Event("change"));

              variant.classList.add("active");
              //alert("Hello Variant changes Execute!");
            }
          });
          
        });
      });
    }
  }

  const modalSwitchVariants = document.querySelector("#modal-variants");
  if (modalSwitchVariants) {
    const variants = document.querySelectorAll(".label-variant");
    if (variants) {
      variants.forEach((variant) => {
        variant.addEventListener("click", () => {
          const width =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;

          if (width < 1150 && variant.closest("variant-radios"))
            return toggleModal(modalSwitchVariants, true);          
        });
      });
    }

    const switchProductsVariants = document.querySelectorAll(
      ".switch-product-container-varians li"
    );

    if (switchProductsVariants) {
      switchProductsVariants.forEach((switchProduct) => {
        switchProduct.addEventListener("click", () => {
          let id = switchProduct.dataset.id;
          let element = document.querySelector(`#${id}`);
          let close = modalSwitchVariants.querySelector(".close-modal");
          close.click();
          element.click();           
        });
      });
    }
  }
});
